import React from 'react'

function TenderTextIGQSB() {
  return (
    <embed src="\pdfs\EAT2.5.1.8_IG-Q-SB_Induction_unit_for_displacement_ventilation_for_vertical_parapet_mounting_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextIGQSB